import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useSetupWizard } from './useSetupWizard';
import SetupDesktop from './Setup.desktop';
import SetupMobile from './Setup.mobile';

const SetupView = choose(SetupDesktop, SetupMobile);

function SetupInner({ event }) {
  const vm = useSetupWizard(event);
  return <SetupView vm={vm} />;
}

// Guided "Setup Event" wizard: Add Function → Add Guests → Add Members.
export default function Setup() {
  return <RequireEvent>{(event) => <SetupInner event={event} />}</RequireEvent>;
}
